"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathType = void 0;
var getPathType = function (loc) {
    if (loc.pathname.includes('/collections/')) {
        return 'Collection';
    }
    else if (loc.pathname.includes('/products/')) {
        return 'Product';
    }
    else if (loc.pathname.includes('/pages/')) {
        return 'Page';
    }
    return null;
};
exports.getPathType = getPathType;
